<h1 mat-dialog-title>{{reward ? 'Edit Reward' : 'Add Reward'}}</h1>

<div mat-dialog-content>
  <div class="subtitle" *ngIf="reward">{{reward.id}}</div>
  <form [formGroup]="form" class="form">
    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Campaigns</mat-label>
      <mat-select formControlName="campaignIds" multiple>
      <mat-option *ngFor="let campaign of campaigns" [value]="campaign.id" [disabled]="isCampaignClosed(campaign)">
          {{campaign.campaignName}} <span *ngIf="isCampaignClosed(campaign)">(inactive)</span>
      </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="file-field">
      <label class="file-label">Image</label>
      <input type="file" (change)="onFileChange($event)">
    </div>

    <div class="colors">
      <mat-form-field appearance="outline">
        <mat-label>Text Color</mat-label>
        <input matInput formControlName="textColor">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Background Color</mat-label>
        <input matInput formControlName="backgroundColor">
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="json-field">
      <mat-label>Banner JSON</mat-label>
      <app-json formControlName="bannerDetails" baseTable="rewards" fieldHint="bannerDetails"></app-json>
    </mat-form-field>

    <app-offer-audiences [control]="form.controls.rewardDetails" [offer]="true"></app-offer-audiences>
    <mat-form-field appearance="outline" class="json-field">
      <mat-label>Reward JSON</mat-label>
      <app-json formControlName="rewardDetails" baseTable="rewards" fieldHint="rewardDetails"></app-json>
    </mat-form-field>

    <mat-form-field appearance="outline" class="json-field">
      <mat-label>Redeem JSON</mat-label>
      <app-json formControlName="redeemDetails" baseTable="rewards" fieldHint="redeemDetails"></app-json>
    </mat-form-field>

    <mat-form-field appearance="outline" class="json-field">
      <mat-label>Visibility Expression</mat-label>
      <textarea matInput formControlName="visibleExpression" rows="4"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="json-field">
      <mat-label>Schedule JSON</mat-label>
      <app-json formControlName="schedule" baseTable="rewards" fieldHint="schedule"></app-json>
    </mat-form-field>

    <div class="location">
      <mat-form-field appearance="outline">
        <mat-label>Latitude</mat-label>
        <input matInput formControlName="latitude">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Longitude</mat-label>
        <input matInput formControlName="longitude">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Radius (meters)</mat-label>
        <input matInput formControlName="radius">
      </mat-form-field>
    </div>

    <div id="reward-map" class="map"></div>
  </form>
</div>

<div class="buttons" mat-dialog-actions>
  <button mat-raised-button color="primary" [disabled]="form.invalid || saving" (click)="save()">Save</button>
  <button mat-stroked-button color="warn" *ngIf="reward" (click)="delete()">Delete</button>
  <button mat-button (click)="cancel()">Cancel</button>
</div>
